import DeleteCell from './deleteCell'
export default DeleteCell
